import { render, staticRenderFns } from "./remediation-ogm-alert.vue?vue&type=template&id=f9a43460&scoped=true"
import script from "./remediation-ogm-alert.vue?vue&type=script&lang=js"
export * from "./remediation-ogm-alert.vue?vue&type=script&lang=js"
import style0 from "./remediation-ogm-alert.vue?vue&type=style&index=0&id=f9a43460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a43460",
  null
  
)

export default component.exports